// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"176":"d579fc97","487":"47717fb6"}[chunkId] + ".chunk.css";
};